import { defaultDatePickerStrings, IDatePickerStrings } from "@fluentui/react";

export const getAge = (dateOfBirth: Date | string, dateToCalculate:Date = new Date()) => {
const dob = new Date(dateOfBirth as Date).getTime();

    //const dateToCompare = new Date(dateToCalculate).getTime();
    //const age = (dateToCompare - dob) / (365.24 * 24 * 60 * 60 * 1000);
    //return Math.floor(age + 0.1);

    var month_diff = dateToCalculate.getTime() - dob;

    //convert the calculated difference in date format  
    var age_dt = new Date(month_diff);

    //extract year from date      
    var year = age_dt.getUTCFullYear();

    //now calculate the age of the user  
    var age = Math.abs(year - 1970);
    return age;
};

export const CzDatePickerStrings: IDatePickerStrings = {
    ...defaultDatePickerStrings,
    months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
    days: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
    shortMonths: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
    shortDays: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
    goToToday: "Dnes",
}

export const getSemesterNumber = (date: Date): number => {

    const semester1 = [9, 10, 11, 12, 1];
    const semester2 = [2, 3, 4, 5, 6, 7, 8];
    const month=date.getMonth()+1;
    if (semester1.indexOf(month)>-1) {
        return 1;
    }
    if (semester2.indexOf(month) > -1) {
        return 1;
    }
    return 0;
}


export const parseDateFromString=(newValue: string, previousValue: Date) => {

    const newValueParts = (newValue || '').trim().split('.');
    const day =
        newValueParts.length > 0 ? Math.max(1, Math.min(31, parseInt(newValueParts[0], 10))) : previousValue.getDate();
    const month =
        newValueParts.length > 1
            ? Math.max(1, Math.min(12, parseInt(newValueParts[1], 10))) - 1
            : previousValue.getMonth();
    let year = newValueParts.length > 2 ? parseInt(newValueParts[2], 10) : previousValue.getFullYear();
    if (year < 100) {
        year += previousValue.getFullYear() - (previousValue.getFullYear() % 100);
    }
    return new Date(year, month, day);
}

export const strToDate=(d:string): Date => {
    const date = d.toString().split('-');
    const year = Number.parseInt(date[2]);
    const month = Number.parseInt(date[0]);
    const day = Number.parseInt(date[1]);
    return new Date(year, month-1, day);
}

export const strTimeToDate = (d: string): Date => {
    const time = d.toString().split(':');
    let hours = Number.parseInt(time[0]);
    let minutes = Number.parseInt(time[1]);
    
    let date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    
    return date;
}


export const strCZToDate = (d: string): Date => {
    const date = d.toString().split('.');
    const year = Number.parseInt(date[2]);
    const month = Number.parseInt(date[1]);
    const day = Number.parseInt(date[0]);
    return new Date(year, month - 1, day);
}


export const dateToStr = (d: Date): string => {

    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    return (month + 1) + "-" + day + "-" + year;
}

export const timeToStr = (d: Date): string => {
        const hours = d.getHours();
        const minutes = d.getMinutes();
        return hours + ":" + minutes;
}

export const dateToCZTimeStr = (d: Date): string => {
    const hours = d.getHours();
    const minutes = d.getMinutes();
    return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + " h.";
}

export const dateToCZStr = (d: Date): string => {

    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    return day + "." + (month + 1) + "." + year;
}